import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-regal-dark via-regal-gray to-regal-dark py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ backgroundImage: 'url("/images/ryan-grewell-hMONKLkuzpI-unsplash.webp")', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 text-white leading-tight" itemprop="headline">
            Your Gateway to Premium UK Casinos
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed" itemprop="description">
            We curate the finest online casino experiences, bringing you exclusive bonuses and trusted platforms that deliver real value.
          </p>
         
          <div className="flex flex-wrap justify-center gap-4 md:gap-6">
            <a
              href="#offers"
              data-discover="true"
              className="text-gray-300 hover:text-regal-red transition-colors font-medium"
            >
              Offers
            </a>
            <a
              href="#about"
              data-discover="true"
              className="text-gray-300 hover:text-regal-red transition-colors font-medium"
            >
              About
            </a>
            <a
              href="#guides"
              data-discover="true"
              className="text-gray-300 hover:text-regal-red transition-colors font-medium"
            >
              Guides
            </a>
            <a
              href="#faq"
              data-discover="true"
              className="text-gray-300 hover:text-regal-red transition-colors font-medium"
            >
              FAQ
            </a>
            <a
              href="#news"
              data-discover="true"
              className="text-gray-300 hover:text-regal-red transition-colors font-medium"
            >
              News
            </a>
            <a
              href="#contact"
              data-discover="true"
              className="text-gray-300 hover:text-regal-red transition-colors font-medium"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

